if (!customElements.get('product-selection-carousel')) {
  customElements.define('product-selection-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.image = this.querySelector('.hamidi-selection__media');
      if (!this.track) return;

      this.dragging = false;
      this.moved = false;
      this.startX = 0;
      this.startScrollLeft = 0;

      // this.track.addEventListener('pointerdown', this.handlePointerDown);
      this.track.addEventListener('pointermove', this.handlePointerMove);
      this.track.addEventListener('pointerup', this.handlePointerUp);
      this.track.addEventListener('pointercancel', this.handlePointerUp);
      this.track.addEventListener('lostpointercapture', this.handlePointerUp);
      this.track.addEventListener('keydown', this.handleKeydown);
      this.track.addEventListener('click', this.handleClick, true);
      this.image.addEventListener('click', this.handleClickImage, true);
    }

    disconnectedCallback() {
      if (!this.track) return;
      // this.track.removeEventListener('pointerdown', this.handlePointerDown);
      this.track.removeEventListener('pointermove', this.handlePointerMove);
      this.track.removeEventListener('pointerup', this.handlePointerUp);
      this.track.removeEventListener('pointercancel', this.handlePointerUp);
      this.track.removeEventListener('lostpointercapture', this.handlePointerUp);
      this.track.removeEventListener('keydown', this.handleKeydown);
      this.track.removeEventListener('click', this.handleClick, true);
    }

    // handlePointerDown = (event) => {
    //   this.moved = false;

    //   // Product buttons must retain their normal link behaviour and should
    //   // never initiate the drag-to-scroll interaction.
    //   if (event.target.closest('.hamidi-selection__button')) {
    //     this.dragging = false;
    //     return;
    //   }

    //   if (event.pointerType === 'mouse' && event.button !== 0) return;
    //   this.dragging = true;
    //   this.startX = event.clientX;
    //   this.startScrollLeft = this.track.scrollLeft;
    //   this.track.setPointerCapture(event.pointerId);
    //   console.log("1")
    //   this.track.classList.add('is-dragging');
    // };

    handlePointerMove = (event) => {
      if (!this.dragging) return;
      const distance = event.clientX - this.startX;
      if (Math.abs(distance) > 6) this.moved = true;
      this.track.scrollLeft = this.startScrollLeft - distance;
    };

    // handlePointerUp = () => {
    //   this.dragging = false;
    //   console.log("2")
    //   this.track.classList.remove('is-dragging');
    // };

    handleClick = (event) => {
      if (event.target.closest('.hamidi-selection__button')) {
        this.moved = false;
        return;
      }

      if (!this.moved) return;
      event.preventDefault();
      event.stopPropagation();
      this.moved = false;
    };

    handleClickImage = (event) => {
      console.log(event)
    };
    handleKeydown = (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const firstCard = this.track.querySelector('[data-carousel-item]');
      const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = (firstCard?.getBoundingClientRect().width || 300) + gap;
      this.track.scrollBy({
        left: event.key === 'ArrowRight' ? distance : -distance,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };
  });
}
